import { getUrlFromIframe, isIframe } from "./EmbededOverlay"
var YOUTUBE = 'youtube'
var VIMEO = 'vimeo'
var DAILYMOTION = 'dailymotion'

var VIMEO_MATCH_RE = /^(?:\/video|\/channels\/[\w-]+|\/groups\/[\w-]+\/videos)?\/(\d+)/


export default function embed(url = '') {
  if (typeof (url) !== typeof ('')) return undefined
  url = /^\/\//.test(url) ? "http:" + url : url;
  if (isIframe(url)) {
    url = getUrlFromIframe(url, false)?.url
  }
  var res = embed.info(url)
  return res && embed[res.source] && embed[res.source](res.id, res.hash ? { query: '?h=' + encodeURIComponent(res.hash) } : undefined)
}

embed.info = function (url) {
  url = new URL(url)
  var id

  id = detectYoutube(url)
  if (id) {
    return {
      id: id,
      source: YOUTUBE,
      url: url.href
    }
  }

  id = detectVimeo(url)
  if (id) {
    return {
      id: id,
      source: VIMEO,
      url: url.href,
      hash: detectVimeoHash(url, id)
    }
  }

  id = detectDailymotion(url)
  if (id) {
    return {
      id: id,
      source: DAILYMOTION,
      url: url.href
    }
  }
}

// For compat with <=2.0.1
embed.videoSource = embed.info

function isVimeoHost(hostname) {
  return hostname === 'vimeo.com' || (hostname?.endsWith('.vimeo.com') ?? false)
}

function detectVimeo(url) {
  // The host test read `hostname === 'vimeo.com' || 'player.vimeo.com' && match`. The bare
  // string is always truthy, so this collapsed to `hostname === 'vimeo.com' || match`: any
  // URL with a leading numeric path segment was claimed as a Vimeo video, and a vimeo.com
  // URL whose path did not match — a vanity URL, or /manage/videos/<id> — dereferenced
  // `null[1]` and threw. Normalising a scheme-less host (RT-810) routes more input here,
  // so gate on the hostname and guard `match`.
  if (!isVimeoHost(url.hostname)) return null
  var match = VIMEO_MATCH_RE.exec(url.pathname)
  return match ? match[1] : null
}

// Unlisted Vimeo videos only play when the privacy hash travels with the embed URL. It
// arrives either as the `h` query param (player.vimeo.com/video/<id>?h=…) or as the path
// segment after the id (vimeo.com/<id>/<hash>). Rebuilding the player URL from the numeric
// id alone dropped it, so Vimeo answered with "Sorry, We're having a little trouble."
function detectVimeoHash(url, id) {
  var hash = url.searchParams.get('h')
  if (hash) return hash
  var segments = url.pathname.split('/').filter(Boolean)
  var idIndex = segments.indexOf(id)
  return idIndex > -1 && segments[idIndex + 1] ? segments[idIndex + 1] : null
}

function detectYoutube(url) {
  if (url.hostname?.indexOf('youtube.com') > -1) {
    return url.searchParams.get('v') || url.pathname.split('/')[2]
  }

  if (url.hostname === 'youtu.be') {
    return url.pathname.split('/')[1]
  }

  return null
}

function detectDailymotion(url) {
  if (url.hostname?.indexOf('dailymotion.com') > -1) {
    return url.pathname.split('/').length === 3 ? url.pathname.split('/')[2].split('_')[0] : url.pathname.split('/')[3].split('_')[0]
  }

  if (url.hostname === 'dai.ly') {
    return url.pathname.split('/')[1]
  }

  return null
}

embed.vimeo = function (id, opts) {
  opts = parseOptions(opts)
  return 'https://player.vimeo.com/video/' + id + opts.query
}

embed.youtube = function (id, opts) {
  opts = parseOptions(opts)
  return 'https://www.youtube.com/embed/' + id + opts.query
}

embed.dailymotion = function (id, opts) {
  opts = parseOptions(opts)
  return 'https://www.dailymotion.com/embed/video/' + id + opts.query
}


function parseOptions(opts) {
  var queryString = ''
  var attributes = ''

  if (opts && opts.query) {
    queryString = opts.query
  }

  if (opts && opts.hasOwnProperty('attr')) {
    attributes = ' ' + Object.keys(opts.attr).map(function (key) {
      return key + '="' + escape(opts.attr[key]) + '"'
    }).join(' ')
  }

  return { query: queryString, attr: attributes }
}



